import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.ListUnrestricted.IRequest;
type Response = Api.Core.Contract.ListUnrestricted.IResponse;
type Headers = Api.Core.Contract.ListUnrestricted.IHeaders;
const url = '/api/Sales/Contract/Unrestricted';
export default async function contractListUnrestrictedApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
